import BaseReducer from "./BaseReducer";
import { defaultGrid } from "../../components/helpers/grid";

class SessionalDetailsReducer extends BaseReducer {
  domain = "Sessional";
  type = "Details";

  initialState = {
    installationId: null,
    grid: defaultGrid,
    showEvents: false,
    includeNonAlerts: true,
    periodType: 0,
    pageCount: 1,
    pageNumber: 1,
    title: null,
  };
}

const reducer = new SessionalDetailsReducer();

export default reducer;
